import { render, staticRenderFns } from "./BeatsPlayer.vue?vue&type=template&id=0d8a0106&"
import script from "./BeatsPlayer.vue?vue&type=script&lang=js&"
export * from "./BeatsPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports